import * as i0 from '@angular/core';
import { Injectable, Directive, Host, Input, HostBinding, inject, TemplateRef, Component, ViewChild, ContentChild, ChangeDetectionStrategy, NgModule } from '@angular/core';
import * as i3 from '@ng-bootstrap/ng-bootstrap';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { firstValueFrom } from 'rxjs';
import { TourService, TourHotkeyListenerComponent, BaseTourProxyAnchor } from 'ngx-ui-tour-core';
const _c0 = ["tourStep"];
function TourStepTemplateComponent_ng_template_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "h5");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 11);
    i0.ɵɵlistener("click", function TourStepTemplateComponent_ng_template_0_Conditional_1_Template_button_click_3_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.tourService.end());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const step_r4 = i0.ɵɵnextContext().step;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(step_r4 == null ? null : step_r4.title);
  }
}
function TourStepTemplateComponent_ng_template_0_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const step_r4 = i0.ɵɵnextContext().step;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2("", (ctx_r2.tourService.steps == null ? null : ctx_r2.tourService.steps.indexOf(step_r4)) + 1, " / ", ctx_r2.tourService.steps == null ? null : ctx_r2.tourService.steps.length, "");
  }
}
function TourStepTemplateComponent_ng_template_0_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 12);
    i0.ɵɵlistener("click", function TourStepTemplateComponent_ng_template_0_Conditional_9_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.tourService.next());
    });
    i0.ɵɵtext(1);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 6);
    i0.ɵɵelement(3, "path", 13);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const step_r4 = i0.ɵɵnextContext().step;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", step_r4 == null ? null : step_r4.nextBtnTitle, " ");
  }
}
function TourStepTemplateComponent_ng_template_0_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 14);
    i0.ɵɵlistener("click", function TourStepTemplateComponent_ng_template_0_Conditional_10_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.tourService.end());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const step_r4 = i0.ɵɵnextContext().step;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", step_r4 == null ? null : step_r4.endBtnTitle, " ");
  }
}
function TourStepTemplateComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, TourStepTemplateComponent_ng_template_0_Conditional_1_Template, 4, 1, "div", 2);
    i0.ɵɵelement(2, "p", 3);
    i0.ɵɵelementStart(3, "div", 4)(4, "button", 5);
    i0.ɵɵlistener("click", function TourStepTemplateComponent_ng_template_0_Template_button_click_4_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.tourService.prev());
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(5, "svg", 6);
    i0.ɵɵelement(6, "path", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, TourStepTemplateComponent_ng_template_0_Conditional_8_Template, 2, 2, "div", 8)(9, TourStepTemplateComponent_ng_template_0_Conditional_9_Template, 4, 1, "button", 9)(10, TourStepTemplateComponent_ng_template_0_Conditional_10_Template, 2, 1, "button", 10);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const step_r4 = ctx.step;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("width", step_r4.stepDimensions == null ? null : step_r4.stepDimensions.width)("min-width", step_r4.stepDimensions == null ? null : step_r4.stepDimensions.minWidth)("max-width", step_r4.stepDimensions == null ? null : step_r4.stepDimensions.maxWidth);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!(step_r4 == null ? null : step_r4.useLegacyTitle) && (step_r4 == null ? null : step_r4.title) ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", step_r4 == null ? null : step_r4.content, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("no-progress", !step_r4.showProgress);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", !ctx_r2.tourService.hasPrev(step_r4));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", step_r4 == null ? null : step_r4.prevBtnTitle, " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(step_r4.showProgress ? 8 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.tourService.hasNext(step_r4) && !step_r4.nextOnAnchorClick ? 9 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r2.tourService.hasNext(step_r4) ? 10 : -1);
  }
}
let NgbTourService = /*#__PURE__*/(() => {
  class NgbTourService extends TourService {
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵNgbTourService_BaseFactory;
        return function NgbTourService_Factory(__ngFactoryType__) {
          return (ɵNgbTourService_BaseFactory || (ɵNgbTourService_BaseFactory = i0.ɵɵgetInheritedFactory(NgbTourService)))(__ngFactoryType__ || NgbTourService);
        };
      })();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: NgbTourService,
        factory: NgbTourService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return NgbTourService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TourStepTemplateService = /*#__PURE__*/(() => {
  class TourStepTemplateService {
    static {
      this.ɵfac = function TourStepTemplateService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TourStepTemplateService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: TourStepTemplateService,
        factory: TourStepTemplateService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return TourStepTemplateService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TourAnchorNgBootstrapDirective = /*#__PURE__*/(() => {
  class TourAnchorNgBootstrapDirective {
    constructor(tourService, tourStepTemplate, element, popoverDirective) {
      this.tourService = tourService;
      this.tourStepTemplate = tourStepTemplate;
      this.element = element;
      this.popoverDirective = popoverDirective;
      this.popoverDirective.autoClose = false;
      this.popoverDirective.triggers = '';
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      this.popoverDirective.toggle = () => {};
    }
    ngOnInit() {
      this.tourService.register(this.tourAnchor, this);
    }
    ngOnDestroy() {
      this.tourService.unregister(this.tourAnchor);
    }
    // noinspection JSUnusedGlobalSymbols
    async showTourStep(step) {
      if (this.popoverDirective.isOpen()) {
        await firstValueFrom(this.popoverDirective.hidden);
      }
      this.isActive = true;
      this.popoverDirective.ngbPopover = this.tourStepTemplate.template;
      if (step.useLegacyTitle) {
        this.popoverDirective.popoverTitle = step.title;
      }
      this.popoverDirective.container = 'body';
      const popoverClass = step.popoverClass ?? '';
      this.popoverDirective.popoverClass = `tour-step ${popoverClass}`;
      this.popoverDirective.placement = (step.placement || 'auto').replace('before', 'left').replace('after', 'right').replace('below', 'bottom').replace('above', 'top');
      const offset = step.backdropConfig?.offset;
      if (offset) {
        this.popoverDirective.popperOptions = options => this.setOffsetModifier(options, offset);
      }
      this.popoverDirective.positionTarget = this.element.nativeElement;
      this.popoverDirective.open({
        step
      });
    }
    setOffsetModifier(options, offset) {
      const offsetModifier = options.modifiers?.find(modifier => modifier.name === 'offset' && modifier.options),
        arrowHeight = 10;
      if (offsetModifier) {
        offsetModifier.options['offset'] = [0, offset + arrowHeight];
      }
      return options;
    }
    // noinspection JSUnusedGlobalSymbols
    hideTourStep() {
      this.isActive = false;
      this.popoverDirective.close();
    }
    static {
      this.ɵfac = function TourAnchorNgBootstrapDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TourAnchorNgBootstrapDirective)(i0.ɵɵdirectiveInject(NgbTourService), i0.ɵɵdirectiveInject(TourStepTemplateService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i3.NgbPopover, 1));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: TourAnchorNgBootstrapDirective,
        selectors: [["", "tourAnchor", ""]],
        hostVars: 2,
        hostBindings: function TourAnchorNgBootstrapDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("touranchor--is-active", ctx.isActive);
          }
        },
        inputs: {
          tourAnchor: "tourAnchor"
        },
        standalone: true,
        features: [i0.ɵɵHostDirectivesFeature([i3.NgbPopover])]
      });
    }
  }
  return TourAnchorNgBootstrapDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TourStepTemplateComponent = /*#__PURE__*/(() => {
  class TourStepTemplateComponent extends TourHotkeyListenerComponent {
    constructor() {
      super(...arguments);
      this.tourStepTemplateService = inject(TourStepTemplateService);
      this.tourService = inject(NgbTourService);
    }
    ngAfterContentInit() {
      this.tourStepTemplateService.template = this.stepTemplate || this.stepTemplateContent || this.defaultTourStepTemplate;
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵTourStepTemplateComponent_BaseFactory;
        return function TourStepTemplateComponent_Factory(__ngFactoryType__) {
          return (ɵTourStepTemplateComponent_BaseFactory || (ɵTourStepTemplateComponent_BaseFactory = i0.ɵɵgetInheritedFactory(TourStepTemplateComponent)))(__ngFactoryType__ || TourStepTemplateComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TourStepTemplateComponent,
        selectors: [["tour-step-template"]],
        contentQueries: function TourStepTemplateComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, TemplateRef, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.stepTemplateContent = _t.first);
          }
        },
        viewQuery: function TourStepTemplateComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 7, TemplateRef);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.defaultTourStepTemplate = _t.first);
          }
        },
        inputs: {
          stepTemplate: "stepTemplate"
        },
        standalone: true,
        features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
        decls: 2,
        vars: 0,
        consts: [["tourStep", ""], [1, "main-container"], [1, "title-container"], [1, "card-text", 3, "innerHTML"], [1, "buttons"], [1, "btn", "btn-sm", "btn-outline-secondary", "prev", 3, "click", "disabled"], ["xmlns", "http://www.w3.org/2000/svg", "width", "16", "height", "16", "fill", "currentColor", "viewBox", "0 0 16 16"], ["d", "M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"], [1, "progress"], [1, "btn", "btn-sm", "btn-outline-primary", "next"], [1, "btn", "btn-sm", "btn-outline-primary"], ["type", "button", "aria-label", "Close", 1, "btn-close", 3, "click"], [1, "btn", "btn-sm", "btn-outline-primary", "next", 3, "click"], ["d", "M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"], [1, "btn", "btn-sm", "btn-outline-primary", 3, "click"]],
        template: function TourStepTemplateComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, TourStepTemplateComponent_ng_template_0_Template, 11, 15, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
        },
        styles: [".tour-step .popover-body{padding:0}.main-container[_ngcontent-%COMP%]{padding:.5rem 1rem .75rem}.title-container[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:space-between;margin-bottom:.5rem;gap:.25rem}.title-container[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;margin-bottom:0;line-height:1.5}.buttons[_ngcontent-%COMP%]{display:grid;grid-template-columns:1fr auto 1fr;align-items:center;gap:8px}.buttons[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{max-width:fit-content}.buttons[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]:last-child{justify-self:flex-end}.buttons[_ngcontent-%COMP%]   .progress[_ngcontent-%COMP%]{font-size:12px;font-weight:700;color:#00000073;white-space:nowrap}.buttons.no-progress[_ngcontent-%COMP%]{grid-template-columns:1fr 1fr}.buttons[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]{display:flex;align-items:center;gap:.25rem}.buttons[_ngcontent-%COMP%]   .btn.prev[_ngcontent-%COMP%]{padding-left:.25rem}.buttons[_ngcontent-%COMP%]   .btn.next[_ngcontent-%COMP%]{padding-right:.25rem}"]
      });
    }
  }
  return TourStepTemplateComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TourProxyAnchorComponent = /*#__PURE__*/(() => {
  class TourProxyAnchorComponent extends BaseTourProxyAnchor {
    constructor() {
      super(...arguments);
      // noinspection JSUnusedGlobalSymbols
      this.anchorDirective = inject(TourAnchorNgBootstrapDirective, {
        host: true
      });
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵTourProxyAnchorComponent_BaseFactory;
        return function TourProxyAnchorComponent_Factory(__ngFactoryType__) {
          return (ɵTourProxyAnchorComponent_BaseFactory || (ɵTourProxyAnchorComponent_BaseFactory = i0.ɵɵgetInheritedFactory(TourProxyAnchorComponent)))(__ngFactoryType__ || TourProxyAnchorComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TourProxyAnchorComponent,
        selectors: [["tour-proxy-anchor"]],
        inputs: {
          anchorEl: "anchorEl"
        },
        standalone: true,
        features: [i0.ɵɵHostDirectivesFeature([{
          directive: TourAnchorNgBootstrapDirective,
          inputs: ["tourAnchor", "anchorId"]
        }]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
        decls: 0,
        vars: 0,
        template: function TourProxyAnchorComponent_Template(rf, ctx) {},
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return TourProxyAnchorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const COMPONENTS = [TourAnchorNgBootstrapDirective, TourStepTemplateComponent, TourProxyAnchorComponent];
let TourNgBootstrapModule = /*#__PURE__*/(() => {
  class TourNgBootstrapModule {
    static {
      this.ɵfac = function TourNgBootstrapModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TourNgBootstrapModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: TourNgBootstrapModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return TourNgBootstrapModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { TourAnchorNgBootstrapDirective, TourNgBootstrapModule, TourProxyAnchorComponent, NgbTourService as TourService, TourStepTemplateComponent };
